export default __webpack_public_path__ + "static/media/1118.21aa0d14.png";